export default "__VITE_ASSET__CNnOa6Cb__"